// extracted by mini-css-extract-plugin
export default {"button":"button_button__aVJXm","primary":"button_primary__x6MLE","secondary":"button_secondary__HRprc"};